/* BN Ultherapy map: Merz/Ultherapy treatment zones with lines per side, drawn over the BN calculator face (900x1200).
   Zones and splits come from the BN Ul-Thermage planner (Apps Script CALC_Ulthermage); red X = never treated.
   A zone value like "50+30" = two layers (4.5 mm + 1.5 mm; 3.0 and 4.5 never on the same area). Used by sections/bn-price-selector.liquid when
   "Face map" = Ultherapy. Source: Marketing/Site/thermage_calc/ultherapy_map.html (Jae 2026-11-01). */
(function(){
const S = 1.5;
const ZP = {
  B:  'M288,234 C300,230 314,230 324,234 C332,237 338,241 342,246 L346,206 C340,200 332,196 324,193 C314,189 300,189 290,193 Z',
  LO: 'M330,252 Q352,284 334,322 L382,328 Q404,286 376,251 Z',
  IO: 'M256,312 Q292,324 330,310 L336,342 Q296,360 258,348 Z',
  // cheek columns stop at the jawline (Jae 11/01: they ran down under the jaw)
  C1: 'M298,375 L340,362 L340,486 L298,509 Z',
  C2: 'M340,362 L386,352 L386,440 L340,486 Z',
  C3: 'M386,352 L414,346 L412,398 L386,440 Z',
  // jawline band sits on the jaw edge, right under the cheek columns
  S2: 'M262,524 L298,509 L340,486 L344,520 L300,543 L262,556 Z',
  S3: 'M340,486 L386,440 L392,472 L344,520 Z',
  S4: 'M386,440 L412,398 L420,430 L392,472 Z',
  SM: 'M226,540 Q240,537 250,536 L254,569 L249,571 Q243,552 226,540 Z',
  N1: 'M282,552 L326,532 L329,655 L282,661 Z',
  N2: 'M326,532 L392,472 L394,646 L329,655 Z',
  N3: 'M392,472 L420,430 L440,636 L394,646 Z'
};
// never treated (Merz map, Jae): front-centre of the neck, mouth corner down to the jaw, temple
const NOGO = [
  'M246,580 L282,566 L282,661 L250,664 Z',
  'M262,447 L298,444 L298,509 L262,524 Z',
  'M348,206 L382,212 L384,250 L346,246 Z'
];
const NAME = { B: 'Brow', LO: 'Outer eye', IO: 'Under eye', C1: 'Inner cheek', C2: 'Mid cheek', C3: 'Front of ear', S2: 'Chin side', S3: 'Jawline', S4: 'Jaw angle', SM: 'Under chin', N1: 'Neck', N2: 'Neck', N3: 'Neck' };

const val = v => String(v).split('+').reduce((a, b) => a + (parseInt(b, 10) || 0), 0);
// centroid of a path (average of its numbers) for the count label
function centre(d){ const n = d.match(/-?\d+(\.\d+)?/g).map(Number); let x = 0, y = 0, k = 0; for (let i = 0; i + 1 < n.length; i += 2) { x += n[i]; y += n[i + 1]; k++; } return [x / k * S, y / k * S]; }

// callouts sit only on clear background: left of the face (eye, jaw) and right of the neck (cheeks, neck)
const GROUPS = [
  { z: ['B', 'LO', 'IO'], t: 'Eye area', at: 'IO', lx: 28, ly: 470, side: 'L' },
  { z: ['S2', 'S3', 'S4', 'SM'], t: 'Jawline', at: 'S2', lx: 28, ly: 900, side: 'L' },
  { z: ['C1', 'C2', 'C3'], t: 'Cheeks', at: 'C3', lx: 880, ly: 770, side: 'R' },
  { z: ['N1', 'N2', 'N3'], t: 'Neck', at: 'N3', lx: 880, ly: 1040, side: 'R' }
];
window.BNUltherapyMap = {
  init: function(maskUrl, done){ done && done(); },
  render: function(svg, zones){
    const z = {};
    zones.forEach(function(p){ const kv = p.split(':'); const id = (kv[0] || '').trim(); if (ZP[id]) z[id] = (kv[1] || '0').trim(); });
  let s = `<defs>
    <linearGradient id="ug" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#E7C27A" stop-opacity=".42"/><stop offset="1" stop-color="#B8892F" stop-opacity=".30"/></linearGradient>
    <pattern id="pass" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(-76)"><line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="1.1" stroke-opacity=".7"/></pattern>
    <pattern id="noX" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M0,0 L10,10 M10,0 L0,10" stroke="#c0392b" stroke-width="1.3"/></pattern>
    <pattern id="pass2" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(14)"><line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="1.1" stroke-opacity=".7"/></pattern>
    <filter id="glow" x="-10%" y="-10%" width="120%" height="120%"><feGaussianBlur stdDeviation="2.2" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
    <filter id="pen"><feTurbulence type="fractalNoise" baseFrequency="1.1" numOctaves="1" seed="3" result="n"/><feDisplacementMap in="SourceGraphic" in2="n" scale="1.4"/></filter></defs>`;
  s += `<g transform="scale(${S})">`;
  for (const d of NOGO) s += `<path d="${d}" fill="rgba(192,57,43,.10)"/><path d="${d}" fill="url(#noX)" opacity=".75"/><path d="${d}" fill="none" stroke="#c0392b" stroke-width="1.4"/>`;
  for (const id of Object.keys(z)) {
    const d = ZP[id];
    s += `<path d="${d}" fill="url(#ug)"/><path d="${d}" fill="url(#pass)" opacity=".5"/>`;
    if (String(z[id]).includes('+')) s += `<path d="${d}" fill="rgba(184,137,47,.22)"/><path d="${d}" fill="url(#pass2)" opacity=".5"/>`;
    s += `<path d="${d}" fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round" filter="url(#glow)" opacity=".95"/>`;
  }
  s += `</g>`;
  // callouts per group (lines per side)
  for (const g of GROUPS) {
    const ids = g.z.filter(id => id in z); if (!ids.length) continue;
    const tot = ids.reduce((a, id) => a + val(z[id]), 0), [ax, ay] = centre(ZP[ids.includes(g.at) ? g.at : ids[0]]);
    const L = g.side === 'L', end = L ? 'start' : 'end', kx = L ? g.lx + 128 : g.lx - 128;
    s += `<path d="M${ax},${ay} L${kx},${g.ly + 14} L${g.lx},${g.ly + 14}" fill="none" stroke="#C9A96E" stroke-width="1.5" opacity=".9"/><circle cx="${ax}" cy="${ay}" r="4.5" fill="#C9A96E"/>`;
    s += `<text x="${g.lx}" y="${g.ly}" text-anchor="${end}" font-family="Lora" font-style="italic" font-size="30" fill="#3F3934">${g.t}</text>`;
    s += `<text x="${g.lx}" y="${g.ly + 44}" text-anchor="${end}" font-family="Josefin Sans" font-weight="700" font-size="15" letter-spacing="2.5" fill="#A67C42">${tot} LINES / SIDE</text>`;
  }  // legend (top-left background)
  s += `<g font-family="Josefin Sans" font-weight="700" font-size="14" letter-spacing="1.5" fill="#7a6f66"><rect x="28" y="40" width="26" height="20" fill="url(#noX)" stroke="#c0392b" stroke-width="1.4"/><text x="64" y="56">NOT TREATED</text>`;
  if (Object.values(z).some(v => String(v).includes('+'))) s += `<rect x="28" y="72" width="40" height="20" rx="10" fill="#fff" stroke="#C9A96E" stroke-width="1.4"/><text x="48" y="87" text-anchor="middle" font-size="11" fill="#3F3934">A·B</text><text x="78" y="88">2 LAYERS · 4.5 + 1.5 MM</text>`;
  s += `</g>`;
  // per-zone counts: small gold-ring badges
  for (const [id, cnt] of Object.entries(z)) {
    const [x, y] = centre(ZP[id]);
    const two = String(cnt).includes('+'), w = two ? 30 : 15;
    s += two ? `<rect x="${x - w}" y="${y - 15}" width="${w * 2}" height="30" rx="15" fill="rgba(255,255,255,.92)" stroke="#C9A96E" stroke-width="1.6"/>` : `<circle cx="${x}" cy="${y}" r="15" fill="rgba(255,255,255,.92)" stroke="#C9A96E" stroke-width="1.6"/>`;
    s += `<text x="${x}" y="${y + 5}" font-family="Josefin Sans" font-weight="700" font-size="13.5" fill="#3F3934" text-anchor="middle">${String(cnt).replace('+', ' · ')}</text>`;
  }
    svg.innerHTML = s;
  }
};
})();